import React from 'react';

const cardStyle = (cardWidth) => ({
  minWidth: cardWidth,
  maxWidth: cardWidth
});

const imageStyle = (imgHeight) => ({
  height: imgHeight
});

const Card = (props) => {
  return (
    <>
      <div>
        <a className='marketplace-card-hyperlink' href={props.path}>
          <div className='marketplace-card' style={cardStyle(props.cardWidth)}>
            <img className='marketplace-card-image' src={props.imageUrl} style={imageStyle(props.imgHeight)}/>
            <div style={{ padding: '20px' }}>
              <p className='marketplace-card-name'>{props.name}</p>
              {props.content}
            </div>
          </div>
        </a>
      </div>
    </>
  );
};

export default Card;
